import { render, staticRenderFns } from "./DoctorRoutePage.vue?vue&type=template&id=d25b485c&"
import script from "./DoctorRoutePage.vue?vue&type=script&lang=js&"
export * from "./DoctorRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports